import React, { useState } from "react";
import { Icon } from "@iconify/react";
import style from "../../../scss/Conteo.module.scss";

// Foto del acta E-14: en el celular "Tomar foto" abre la cámara trasera y
// "Galería" permite elegir una foto ya tomada.
const FotoE14Component = ({ fotoUrl, onSeleccionar, deshabilitado }) => {
  const [ampliada, setAmpliada] = useState(false);

  const handleArchivo = (event) => {
    const archivo = event.target.files?.[0];
    // se limpia para poder volver a elegir el mismo archivo
    event.target.value = "";
    if (archivo) onSeleccionar(archivo);
  };

  return (
    <section className={style.foto}>
      <h2 className={style.seccionTitulo}>
        <Icon icon="mdi:file-image-outline" aria-hidden="true" /> Foto del E-14
      </h2>

      {fotoUrl ? (
        <button
          type="button"
          className={style.fotoBoton}
          onClick={() => setAmpliada(!ampliada)}
          title={ampliada ? "Reducir foto" : "Ampliar foto"}
        >
          <img
            src={fotoUrl}
            alt="Foto del acta E-14"
            className={`${style.fotoVista} ${ampliada ? style.fotoAmpliada : ""}`}
          />
        </button>
      ) : (
        <p className={style.fotoVacia}>
          <Icon icon="mdi:camera-plus-outline" aria-hidden="true" className={style.fotoVaciaIcono} />
          Aún no se ha tomado la foto del acta.
        </p>
      )}

      {!deshabilitado && (
        <div className={style.acciones}>
          <label className={`btn btn-outline-primary ${style.boton}`}>
            <Icon icon="mdi:camera-outline" aria-hidden="true" /> {fotoUrl ? "Tomar otra foto" : "Tomar foto"}
            <input
              type="file"
              accept="image/*"
              capture="environment"
              className="visually-hidden"
              onChange={handleArchivo}
            />
          </label>
          <label className={`btn btn-outline-secondary ${style.boton}`}>
            <Icon icon="mdi:image-outline" aria-hidden="true" /> Galería
            <input type="file" accept="image/*" className="visually-hidden" onChange={handleArchivo} />
          </label>
        </div>
      )}
    </section>
  );
};

export default FotoE14Component;
